import React, { useEffect, useState } from 'react';
import { BasicCheckbox } from '../BasicCheckbox/BasicCheckbox';
import styles from './RangeValueSlider.module.scss';

export interface SliderWithInputProps {
  label: string;
  unit: string;
  min: number | string;
  max: number | string;
  defaultValue: number;
  step?: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
  showCheckbox?: boolean;
  checkboxChecked?: boolean;
  onCheckboxChange?: (checked: boolean, value: number) => void;
}

export const RangeValueSlider: React.FC<SliderWithInputProps> = ({
  label,
  unit,
  min,
  max,
  defaultValue,
  step,
  onChange,
  disabled,
  showCheckbox,
  checkboxChecked,
  onCheckboxChange,
}) => {
  const [value, setValue] = useState<number>(defaultValue);

  // Keep internal value in sync when defaultValue prop changes (e.g., after restore)
  useEffect(() => {
    if (typeof defaultValue === 'number' && !Number.isNaN(defaultValue)) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  // Determine disabled state: either from checkbox or from prop
  const isDisabled = showCheckbox
    ? !checkboxChecked
    : disabled;

  return (
    <div className={styles.container}>
      <div className={styles.labelCheckbox}>
      {showCheckbox && onCheckboxChange && (
        <BasicCheckbox
          checked={checkboxChecked as boolean}
          onChange={(checked) => onCheckboxChange(checked, value)}
        />
      )}
      <label className={styles.label}>
        {label} ({unit})
        </label>
      </div>
      <div className={styles.inputSlider} data-disabled={isDisabled}>
        <div className={styles.displayValue}>{value}</div>
        <input
          id="time-slider"
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          disabled={isDisabled}
          onChange={(e) => {
            const newVal = parseFloat(e.target.value);
            setValue(newVal);
            onChange && onChange(newVal);
          }}
          className={styles.slider}
          tabIndex={0}
        />
        <div className={styles.minMax}>
          <span>{min}</span>
          <span>{max}</span>
        </div>
      </div>
    </div>
  );
};
